<template>
  <div class="d-flex flex-column pix">
    <img :src="qrCode" alt="Pix QR Code" />
    <a v-clipboard:copy="copyAndPaste" href="#" class="button2">
      Copia e cola pix!
    </a>
  </div>
</template>

<script>
export default {
  name: "Pix",
  props: {
    qrCode: {
      type: String,
      default: ""
    },
    copyAndPaste: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss">
.pix {
  border: solid 1px grey;
  margin: -1px;
  .button2 {
    border-radius: 0;
    border-color: grey;
  }
}
</style>
